export default "__VITE_ASSET__DVmua3x7__"